export default {"src":"/_next/static/media/data-warehouse.257f2efc.svg","height":800,"width":800,"blurWidth":0,"blurHeight":0};